import TreeList, { Column, Scrolling, Selection, SearchPanel as TreeSearch } from "devextreme-react/tree-list";
import React, { useEffect, useState } from "react";
import { Col, Row } from "react-bootstrap";
import { Employee, EmployeeService } from "../../../services/department-viags/employee-viags.service";
import DataGrid, { FilterRow, HeaderFilter, Paging, SearchPanel } from "devextreme-react/data-grid";
import { UserDocumentModal } from "./user-document-modal";
import { FontFa, Icon } from "../../../components";
import { Modal } from "antd";
import { useSearchParams } from "../../../hook/use-search-params";
import { DepartmentDocumentModal } from "./department-document-modal";
import { DepartmentService } from "../../../services/department-viags/department.service";
import { Department } from "../../landing";

type UserDepartmentModalType = {
  onClose: () => void;
  isOpen: boolean;
};

export const UserDepartmentModal = (props: UserDepartmentModalType) => {
  const { onClose, isOpen } = props;
  const [selectedDepartment, setSelectedDepartment] = useState(null as any);
  const [selectedEmployee, setSelectedEmployee] = useState<any>([]);

  const [isOpenUserDocumentModal, setIsOpenUserDocumentModal] = useState(false);
  const [isOpeDepartmentDocumentModal, setIsOpeDepartmentDocumentModal] = useState(false);

  const { searchParams, pushSearchParams } = useSearchParams();

  const [employeeData, setEmployeeData] = useState<Employee[]>([]);
  const [departmentList, setDepartmentList] = useState<Department[]>([]);
  const [isLoading, setIsLoading] = useState(false);

  const getDepartment = async () => {
    setIsLoading(true);
    const res = await DepartmentService.getDepartmentListV5();
    if (!res) return;
    setDepartmentList(res);
    setIsLoading(false);
  };

  const getEmployee = async (departmentId: string) => {
    const res = await EmployeeService.getEmployeeListV5(departmentId);
    if (!res) return;
    return res;
  };

  const getIsView = (eEmail: string) => {
    if (!Array.isArray(selectedEmployee)) return false;
    const isView = selectedEmployee?.find((e: any) => e.employeeEmail.toLowerCase() === eEmail);
    return isView?.isView || false;
  };

  const getIsEdit = (eEmail: string) => {
    if (!Array.isArray(selectedEmployee)) return false;
    return selectedEmployee?.find((e: any) => e.employeeEmail.toLowerCase() === eEmail)
      ? selectedEmployee?.find((e: any) => e.employeeEmail.toLowerCase() === eEmail).isEdit
      : false;
  };

  const handleCellClick = async (e: any) => {
    setSelectedDepartment(e?.data);
    const treeList = e.component;
    const targetRowKey = e.key;
    treeList.expandRow(targetRowKey);

    const departmentId = e?.row?.key;
    const employeeDepartmentData = await getEmployee(departmentId);
    if (employeeDepartmentData && employeeDepartmentData.length > 0) {
      employeeDepartmentData.forEach((e: any) => {
        e.isView = getIsView(e?.employeeEmail?.toLowerCase());
        e.isEdit = getIsEdit(e?.employeeEmail?.toLowerCase());
      });
      setEmployeeData(employeeDepartmentData);
    } else {
      setEmployeeData([]);
    }
  };

  const handleNameRender = (e: any) => {
    return (
      <div
        style={{
          cursor: "pointer",
          padding: "4px",
          backgroundColor: selectedDepartment?.id === e.data.id ? "#bae6fd" : "",
        }}
      >
        <span className="mr-1 text-warning">
          {" "}
          <FontFa name="faBuilding" size={"xs"} />
        </span>
        <span>{e.data.name}</span>
      </div>
    );
  };

  const hanldeTextChange = async (e: any) => {
    searchParams.set("deptCode", "VIAGS");
    pushSearchParams(searchParams);
  };

  const onCellDbClick = (emp: any) => {
    searchParams.set("empCode", emp.data.employeeCode);
    searchParams.delete("isDepartment");
    pushSearchParams(searchParams);
    setIsOpenUserDocumentModal(true);
    setSelectedEmployee(emp.data);
  };

  const hanldeSelectDepartment = () => {
    searchParams.delete("empCode");
    searchParams.delete("start");
    searchParams.delete("end");
    searchParams.set("isDepartment", "true");
    pushSearchParams(searchParams);
    setIsOpeDepartmentDocumentModal(true);
  };

  const handleCloseUserDocumentModal = () => {
    setIsOpenUserDocumentModal(false);
    searchParams.delete("start");
    searchParams.delete("end");
    pushSearchParams(searchParams);
  };

  useEffect(() => {
    getDepartment();
  }, []);

  return (
    <>
      <Modal
        open={isOpen}
        zIndex={1551}
        width={"max(90vw,700px)"}
        centered
        cancelText="Đóng"
        onCancel={onClose}
        okText="Chọn phòng ban"
        onOk={hanldeSelectDepartment}
        destroyOnClose
        okButtonProps={{ disabled: !selectedDepartment }}
        title={
          <div>
            <h5 style={{ color: "#00a9c4" }}>Chọn nhân viên hoặc phòng ban</h5>
            {selectedDepartment && <div>🏢 {selectedDepartment.name}</div>}
          </div>
        }
      >
        <div>
          <Row>
            {isLoading ? (
              <Icon.Loading />
            ) : (
              <Col sm="3" md="3" className="w-full">
                <TreeList
                  id="Folder"
                  dataSource={departmentList}
                  showRowLines={false}
                  showBorders={false}
                  columnAutoWidth={true}
                  allowColumnReordering={false}
                  itemsExpr="viagsDepartmentChild"
                  dataStructure="tree"
                  expandNodesOnFiltering={false}
                  autoExpandAll={false}
                  onCellClick={handleCellClick}
                  allowColumnResizing={false}
                  height={500}
                >
                  <Scrolling mode="standard" />

                  <Selection allowSelectAll={false} mode="single" />
                  <TreeSearch visible={true} placeholder="Nhập tên phòng ban" width={300} />
                  <Column
                    dataField="name"
                    caption="Phòng/Ban"
                    key="id"
                    cellRender={handleNameRender}
                    allowReordering={false}
                    allowSorting={false}
                  />
                </TreeList>
              </Col>
            )}
            <Col sm="9" md="9">
              <DataGrid
                id="employeeEmail"
                dataSource={employeeData}
                showRowLines={true}
                showBorders={true}
                columnAutoWidth={true}
                className="px-2"
                allowColumnReordering={false}
                allowColumnResizing={false}
                onCellDblClick={onCellDbClick}
                noDataText="Anh/Chị chưa chọn phòng ban hoặc phòng ban chưa có nhân sự nào"
              >
                <Paging defaultPageSize={10} />
                <HeaderFilter visible={true} />
                <FilterRow visible={true} applyFilter={true} />
                <SearchPanel
                  visible={true}
                  placeholder="Nhập tên nhân sự cần tìm"
                  width={400}
                  onTextChange={hanldeTextChange}
                />
                <Column dataField="employeeCode" caption="Mã nhân sự" dataType="string"></Column>
                <Column dataField="employeeName" caption="Tên nhân sự"></Column>
                <Column dataField="employeeEmail" caption="Email"></Column>
              </DataGrid>
              <h6 style={{ paddingLeft: "10px", paddingTop: "5px" }}>
                Nhấp 2 lần vào một nhân viên để xem các tài liệu được ban hành tới nhân viên đó
              </h6>
            </Col>
          </Row>
        </div>
      </Modal>
      <UserDocumentModal
        onClose={() => handleCloseUserDocumentModal()}
        isOpen={isOpenUserDocumentModal}
        selectedEmployee={selectedEmployee}
      />

      <DepartmentDocumentModal
        onClose={() => setIsOpeDepartmentDocumentModal(false)}
        isOpen={isOpeDepartmentDocumentModal}
        selectedDepartment={selectedDepartment}
      />
    </>
  );
};
